import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';

const tabs = [
  {
    "title": "Bot configuration",
    "resource": "bots/botconfig",
    "columns": [
      "id",
      "name",
      "pair",
      "strategy",
      "enabled",
      "stopped",
      "min_order_quantity",
      "max_order_quantity",
      "next_launch"
    ]
  },
  {
    "title": "Pair controls",
    "resource": "core/pairsettings"
  },
  {
    "title": "Order activity",
    "resource": "admin_rest/allorder",
    "columns": [
      "id",
      "created",
      "user",
      "pair",
      "operation",
      "type",
      "quantity",
      "quantity_left",
      "price",
      "state"
    ]
  }
];

export default function BotsPage() {
  return <ResourceWorkspace title="Trading bots"  tabs={tabs} />;
}
